import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'hb-maintenancemode',
  templateUrl: './maintenanceMode.component.html',
  styleUrls: ['./maintenanceMode.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MaintenanceModeComponent {
  public largeLogo = '/images/brand/atm-logo-positive-gbm.svg';

  constructor() {}
}
